<template>
  <form v-on:submit.prevent="addressSubmit()" class="box orange left-box-sizing text-left">
    <!-- box header -->
    <div class="header">
      <span class="step mx-2 mx-md-4">1</span>
      <h2>
        Delivery Information
        <small>
          <b>{{ fname }}{{ ` ${lname}` }}</b>,
          +91{{ phone }}{{ `, ${email}` }}
        </small>
      </h2>
    </div>

    <!-- box-content -->
    <div class="content">
      <div class="px-3 px-lg-5">
        <div class="form">
          <div class="row w-100 my-4">
            <div class="col-12">
              <div>
                <div class="input-group">
                  <input class="text w-100" type="text" name="address1" id="address1" v-model="$v.address1.$model" required>
                  <label :class="[$v.address1.$model=='' ? '' : 'filled', 'label']" for="address1">Address Line 1*</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row w-100 mb-4">
            <div class="col-12">
              <div>
                <div class="input-group">
                  <input class="text w-100" type="text" name="address2" id="address2" v-model="address2">
                  <label :class="[address2=='' ? '' : 'filled', 'label']" for="address2">Address Line 2</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row w-100 mb-4">
            <div class="col-12">
              <div>
                <div class="input-group">
                  <input class="text w-100" type="text" name="city" id="city" v-model="$v.city.$model" required>
                  <label :class="[$v.city.$model=='' ? '' : 'filled', 'label']" for="city">City*</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row w-100 mb-4">
            <div class="col-12">
              <div>
                <div class="input-group">
                  <input class="text w-100" type="text" name="state" id="state" v-model="$v.state.$model" required>
                  <label :class="[$v.state.$model=='' ? '' : 'filled', 'label']" for="state">State*</label>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row w-100 mb-4">
            <div class="col-12">
              <div>
                <div class="input-group">
                  <input class="text w-100" type="number" name="pin" id="pin" v-model="$v.pin.$model" required>
                  <label :class="[$v.pin.$model=='' ? '' : 'filled', 'label']" for="pin">Pin Code*</label>
                </div>
                <small v-if="$v.pin.$dirty && $v.pin.$invalid" class="input-error text-danger">
                  (Please enter a valid Pin Code)
                </small>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- box footer -->
    <div class="footer">
      <div class="px-3 form">
        <small class="ml-2 ml-md-5" style="color: #909090;">
          * Indicates Mandatory Fields
        </small>
        <input
          class="mx-sm-auto ml-md-auto mr-md-0"
          type="submit"
          value="Next"
          :disabled="$v.$invalid"
        >
      </div>
    </div>
  </form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: "DeliveryAddress",
  data() {
    return {
      address1: '',
      address2: '',
      city: '',
      state: '',
      // pin: '',
    }
  },
  mixins: [validationMixin],
  validations: {
    address1: {
      required,
    },
    city: {
      required,
    },
    state: {
      required,
    },
    // pin: {
    //   minLength: minLength(6),
    //   maxLength: maxLength(6), // pin code should be exactly 6 digit long
    //   numeric,
    //   required,
    // },
  },
  props: ["phone", "fname", "lname", "email", "address-required"],
  methods: {
    addressSubmit() {
      // emit the form details to the parent for processing
      this.$emit('address', {
        address1: this.address1,
        address2: this.address2,
        city: this.city,
        state: this.state,
        // pin: this.pin,
      })
    }
  },
  created() {
    // skip if the item is a course
    if (this.addressRequired===0) this.$emit('skip')
  }
}
</script>

<style scoped>
  .box > .header > .step {
    color:#fff;
    border-radius: 1000px;
    background: #f36f2e;
    height: 36px;
    width: 36px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .box > .content {
    overflow: hidden;
  }

  .box > .content .form {
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  /* material-like text boxes */
  .input-group {
    position: relative;
  }

  .input-group > .label {
    position: absolute;
  }
  .input-group > .text:hover, .label:hover {
    cursor: pointer;
  }

  .text {
    outline: none;
    padding: 10px;
    border-radius: 4px;
    border: solid 1px #A0A0A0;
  }

  .label {
    padding: 11px;
    top: 0;
    left: 0;
    transition: all 0.5s;
    color: #A0A0A0;
    white-space: nowrap;
  }

  .text:focus {
    border: solid 1px #F36F2E;
  }

  .text:focus ~ .label {
    padding: 0 4px;
    font-size: 0.8rem;
    top: -0.4rem;
    left: 0.4rem;
    background: #fff;
    color: #F36F2E;
    
    transition: all 0.5s;
  }

  .filled {
    padding: 0 4px;
    font-size: 0.8rem;
    top: -0.4rem;
    left: 0.4rem;
    background: #fff;
  }
</style>